export const DOMAIN = 'consentConfigDetails.configuration.cookies';
